import { createSlice } from "@reduxjs/toolkit";



const initialState = {
    checked : true,
};


const checkedSlice =  createSlice({
    name: "checked",  //checked isimli bir slice oluşturdum.
    initialState,
    reducers: {
        setChecked: (state, action) => {  //setchecked adında action oluşturdum.Store'da ki checked durumunu güncellemek için kullanıcam
            state.checked = action.payload;
            console.log("checked state updated:", state.checked);
            return state;
            
        },
    },
});

export const  { setChecked } = checkedSlice.actions; //action creator'ı dışa aktardım.
export default checkedSlice.reducer;

//Bu sayfada Redux store'un durumunu ve güncellemek için kullanacağım actionları tanımladım
//Action: Aksiyonlar uyg.içindeki bir olayı temsil ederler ve uyg.durumunu değiştirmek için kullanılırlar.

//createSlice: Bunu redux slicer oluşturmak için kullanıyoruz.Bu fonk bir nesne döndürüyor.Bu nesne slice'nin reducer'ını, 
//action creatorlarını ve action türlerini içerir.Buradaki örnekte  checked isminde slice oluşturuyoruz.
//Bu slice setChecked adlı bir action creator'a ve buna bağlı bir reducer'a sahip.

//setChecked action creator, bir action oluşturan fonksiyondur.Bu action , reducer'a geçirilen 'action' parametresi ile güncellenir.
 